//Build-In
import React, {Suspense, Fragment} from 'react'
import {
    Card,
    CardBody,
    CardTitle,
    DropdownMenu,
    DropdownToggle,
    Nav,
    NavItem,
    NavLink,
    UncontrolledButtonDropdown
} from "reactstrap";
import './assets/leads.css';
import {currencyFormatter, getLeadFieldName, getProfileFields, showToast} from "../../Common/Appcommon";
import HorizontalTimeline from "./HorizontalTimeline";
import dateFormat from "dateformat";
import {faCircleDot} from "@fortawesome/free-solid-svg-icons/faCircleDot";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPencil} from "@fortawesome/free-solid-svg-icons/faPencil";
import {faEllipsisVertical} from "@fortawesome/free-solid-svg-icons/faEllipsisVertical";
import {Row, Col} from "react-bootstrap";
import {faCircleCheck} from "@fortawesome/free-solid-svg-icons/faCircleCheck";
import {faWhatsapp} from "@fortawesome/free-brands-svg-icons/faWhatsapp";
import {faCalendarDays} from "@fortawesome/free-solid-svg-icons/faCalendarDays";
import {faClipboard} from "@fortawesome/free-solid-svg-icons/faClipboard";
import {faCalendarPlus} from "@fortawesome/free-solid-svg-icons/faCalendarPlus";
import Tabs from "react-responsive-tabs";
import QuickReply from "../QuickReply";
import Subtable from "./Subtable";
import Form from "./Form";
import TaskActions from "./TaskActions";
import cx from "classnames";
import requestApi from "../../services/requestApi.service";
import DeleteConfirm from "../../Common/DeleteConfirm";

class ConfigView extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            profileFields : [],
            isOpen : false,
            actionType : "",
            deleteConfirmModal: false,
            nestedModal : false,
            closeAll : false,
            forceErrorStr : "",
            massSelect : [],
            dataRow: props.row,
        }
        this.toggleModal = this.toggleModal.bind(this);
        this.toggleNestedModal = this.toggleNestedModal.bind(this);
        this.toggleAllModal = this.toggleAllModal.bind(this);
    }

    async componentDidMount () {
        let profileFields = await getProfileFields();

        if(profileFields !== undefined && profileFields !== "" && profileFields !== null){
            this.setState({profileFields})
        }
    }

    openFormModal = () => {
        this.setState({
            isOpen : true
        })
    }

    closeFormModal = () => {
        this.setState({
            isOpen : false
        })
    }

    toggleFormModal = () => {
        let isOpen = this.state.isOpen;
        this.setState({
            isOpen : !isOpen
        })
    }

    onOpenWhatsappChatAction = (e, formId) => {
        window.open("#/inbox/chat/"+formId,"_blank");
    }

    openWhatsAppMoreAction = (e, type) => {
        if(this.state.actionType === type){
            type = "";
        }
        this.setState({
            actionType : type
        })
    }

    onAfterCreateTask = (e) => {
        this.setState({
            actionType : ""
        })
    }


    async toggleModal() {
        this.setState({
            deleteConfirmModal: !this.state.deleteConfirmModal,
        });
    }

    async toggleNestedModal() {
        this.setState({
            nestedModal: !this.state.nestedModal,
            closeAll : false
        });
    }
    async toggleAllModal() {
        this.setState({
            deleteConfirmModal: false,
            nestedModal : false,
            closeAll : false
        });
    }

    deleteLeads = async (e, isConfirm = false, isForce = false, rowId) => {
        let massSelect = [rowId];
        this.setState({
            massSelect
        })
        if(!isConfirm){
            await this.toggleModal();
        } else {
            let selectedRowIds = this.state.massSelect;
            let formInfo = this.props.formDetail[0];
            let moduleName = formInfo[0];
            let params = {
                "ENTITY": "FORMPROCESS",
                "OPERATION": "DELETE",
                "FORMNAME": formInfo[1],
                "MODULENAME" : moduleName,
                "FORMTYPE" : "",
                "Check Reference" :isForce,
                "FORM_INPUTFIELDS" : selectedRowIds,
                "auditinfo" : {"displaystring":selectedRowIds.length + " Records"},
            }
            let deleteresponse = await requestApi.processServerRequest(params);
            if(deleteresponse.issuccess) {
                let deleteRes = deleteresponse.data;
                if (deleteRes != "" && deleteRes != "Active") {
                    await this.setState({
                        forceErrorMsg: deleteRes,
                    })
                    await this.toggleNestedModal();
                } else {
                    await this.setState({
                        massSelect: [],
                    })

                    showToast(selectedRowIds.length + ' records deleted successfully.')
                    await this.toggleAllModal();
                    this.props.lead.state.isRowSelected = false;
                    this.props.lead.state.dataRow = {};
                    await this.props.lead.loadFormData(true, true, true);
                }
            } else if (deleteresponse.errormsg != ""){
                showToast(deleteresponse.errormsg, "top-right","error");
            }
        }
    }

    updateDataRow = (dataRow) => {
        this.setState(dataRow);
    }

    render(){
        let {profileFields, formDetail} = this.props;
        let row = this.state.dataRow;
        if(profileFields.length > 0){
            let contactName = getLeadFieldName("contactname");
            let mobile = getLeadFieldName("mobile");
            let emailAddress = getLeadFieldName("emailAddress");
            let dealField = profileFields[3];
            let expectedCloseField = profileFields[4];
            let stageField = profileFields[5];
            let formname = formDetail[0][1];
            return (
                <Fragment>
                    <Form isNew={false} isOpen={this.state.isOpen} formDetail={formDetail} dataRow={this.state.dataRow} updateDataRow={this.updateDataRow} toggleFormModal={this.toggleFormModal} />
                    <div className={'lead-config-container'}>
                        <div className={'lead-config-toppanel'}>
                            <Card className="main-card">
                                <CardBody>
                                    <div className={'config-container flex'}>
                                        <div className={'configview-panel col-md-12'}>
                                            <div className={'title-header-container flex'}>
                                                <div className={'title-header col-md-11'}>
                                                    <span>{row['Lead Title']}</span>
                                                </div>
                                                <div className={'configaction-panel'}>
                                                    <div className={'config-buttons d-flex'}>
                                                        <div className="form-field-wrapper">
                                                            <a className="field-input sort-btn " onClick={(e) => {this.openFormModal()}}>
                                                                <span><FontAwesomeIcon icon={faPencil}/></span>
                                                            </a>
                                                        </div>
                                                        <div className="form-field-wrapper lead-more-action-dropdown">
                                                            <UncontrolledButtonDropdown >
                                                                <DropdownToggle color="link" className={cx('p-0 dropdown-listtbl-icon')}>
                                                                    <a className="field-input sort-btn more-action-btn">
                                                                        <span><FontAwesomeIcon icon={faEllipsisVertical}/></span>
                                                                    </a>
                                                                </DropdownToggle>
                                                                <DropdownMenu end className="rm-pointers dropdown-menu-md" >
                                                                    <Nav vertical>
                                                                        <NavItem>
                                                                            <NavLink className={"cursor-pointer"} onClick={(e) => this.deleteLeads(e,false, false, row[formname+"_id"])}>
                                                                                Delete
                                                                            </NavLink>
                                                                        </NavItem>
                                                                    </Nav>
                                                                </DropdownMenu>
                                                            </UncontrolledButtonDropdown>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                            <div className={"lead-info flex-center-v"}>
                                                <div className={'lead-fieldinfo-line'}>
                                        <span className={'lead-field-label'}>
                                            {contactName}
                                        </span>
                                                    <span className="pL5 pR5">:</span>
                                                    <span className={'lead-field-value'}>
                                            {row[contactName]}
                                        </span>
                                                </div>
                                                {row[emailAddress] !== "" && row[emailAddress] !== null &&
                                                <div className={'lead-fieldinfo-line'}>
                                                    <span className="ux-bullet-primary"></span>
                                                    <span className={'lead-field-label'}>
                                            {emailAddress}
                                        </span>
                                                    <span className="pL5 pR5">:</span>
                                                    <span className={'lead-field-value'}>
                                            {row[emailAddress]}
                                        </span>
                                                </div>
                                                }
                                                {row[mobile] !== "" && row[mobile] !== null && <div className={'lead-fieldinfo-line'}>
                                                    <span className="ux-bullet-primary"></span>
                                                    <span className={'lead-field-label'}>
                                            {mobile}
                                        </span>
                                                    <span className="pL5 pR5">:</span>
                                                    <span className={'lead-field-value'}>
                                            {row[mobile]}
                                        </span>
                                                </div>

                                                }
                                            </div>
                                            <div className={"lead-info flex-center-v"}>
                                                <div className={'lead-fieldinfo-line'}>
                                        <span className={'lead-field-label'}>
                                            {dealField['labelname']}
                                        </span>
                                                    <span className="pL5 pR5">:</span>
                                                    <span className={'lead-field-value'}>
                                            {currencyFormatter(row[dealField['labelname']])}
                                        </span>
                                                </div>
                                                {row[expectedCloseField['labelname']] !== "" && row[expectedCloseField['labelname']] !== null &&
                                                <div className={'lead-fieldinfo-line'}>
                                                    <span className="ux-bullet-primary"></span>
                                                    <span className={'lead-field-label'}>
                                                {expectedCloseField['labelname']}
                                        </span>
                                                    <span className="pL5 pR5">:</span>
                                                    <span className={'lead-field-value'}>
                                            {row[expectedCloseField['labelname']] !== "" && row[expectedCloseField['labelname']] !== "0000-00-00" ? dateFormat(row[expectedCloseField['labelname']],'dd/mmm/yyyy') : "-"}
                                        </span>
                                                </div>
                                                }
                                            </div>
                                            <HorizontalTimeline />
                                        </div>

                                    </div>
                                </CardBody>
                            </Card>
                            <Card className={'mt-2'}>
                                <CardBody>
                                    <div className={'config-moreactions'}>
                                        <Row>
                                            <Col md={"3"} className={'text-center cursor-pointer'}>
                                                <div onClick={e => {this.onOpenWhatsappChatAction(e, row[formname+"_id"])}} className={'lead-actions d-grid text-center'}>
                                                    <FontAwesomeIcon className={'lead-action-icons'} icon={faWhatsapp}/>
                                                    <span>Send WhatsApp</span>
                                                </div>
                                            </Col>
                                            <Col md={"3"} className={'text-center cursor-pointer'}>
                                                <div onClick={e => {this.openWhatsAppMoreAction(e, 'reminder')}} className={`lead-actions d-grid text-center ${this.state.actionType === "reminder" ? 'lead-actions-active' : ''}`}>
                                                    <FontAwesomeIcon className={'lead-action-icons calender-action'} icon={faCalendarDays}/>
                                                    <span>Add Reminder</span>
                                                </div>
                                            </Col>
                                            <Col md={"3"} className={'text-center cursor-pointer'}>
                                                <div onClick={e => {this.openWhatsAppMoreAction(e, 'addtask')}} className={`lead-actions d-grid text-center ${this.state.actionType === "addtask" ? 'lead-actions-active' : ''}`}>
                                                    <FontAwesomeIcon className={'lead-action-icons task-action'} icon={faCalendarPlus}/>
                                                    <span>Add Task</span>
                                                </div>
                                            </Col>
                                            <Col md={"3"} className={'text-center cursor-pointer'}>
                                                <div onClick={e => {this.openWhatsAppMoreAction(e, 'addnote')}} className={`lead-actions d-grid text-center ${this.state.actionType === "addnote" ? 'lead-actions-active' : ''}`}>
                                                    <FontAwesomeIcon className={'lead-action-icons notes-action'} icon={faClipboard}/>
                                                    <span>Add Note</span>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>

                                </CardBody>
                            </Card>
                            <div>
                                {this.state.actionType !== "" && <TaskActions leadRow={row} onAfterCreateTask={this.onAfterCreateTask} leadId={row[formname+"_id"]} leadFormname={formname} actionType={this.state.actionType} /> }
                            </div>
                            <Card className={'mt-2'}>
                                <CardBody>
                                    <Subtable />
                                </CardBody>
                            </Card>
                        </div>
                    </div>
                    <DeleteConfirm deleteMsg={"Do you want to delete the lead? "} form={this} onDelete={this.deleteLeads} />

                </Fragment>
            )
        }

    }

}

export default ConfigView;
